import React from 'react';

import { Users } from '../..';
import { Navigation } from '../../../utils/navigation';

export const Admins = (props) => (
  <Users title='MedHaul Admins' Navigation={Navigation()} addNewBtnTitle='Add New MedHaul Admin' managedRole='Admin' {...props} />
);
